export enum StatusAtendimentoUsuario {
    Atendido = 0,
    AguardandoResposta = 1,
    AtendimentoCancelado = 2,
    Pendente = 3,
}
